import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import sanityClient from "../../client";
import BlockContent from "@sanity/block-content-to-react";
import { Link } from "react-router-dom";
import NavEn from "./NavEn";
import FooterEn from "./FooterEn";
import Loading from "../components/Loading";
function SingleProject() {
  const [loading, setLoading] = useState(true);
  const [img, setImg] = useState(null);

  const { slug } = useParams();

  const [project, setProject] = useState(null);
  const [antherProjects, setAntherProjects] = useState(null);

  useEffect(() => {
    document.querySelector("html").lang = "en";
  }, []);
  useEffect(() => {
    // get project Data
    sanityClient
      .fetch(
        `
      *[_type=="projects" && Slug.current=="${slug}"]{
        "description": description.en,
        "images": images[].asset->url,
        "projectType": projectType.en,
        "address": address.en,
        "type" : type.en,
        "name": name.en,
      }
    `
      )
      .then((data) => {
        setProject(data[0]);

        document.title = `${data[0].name} - CompanyName`;
        setLoading(false);
      });

    // Get Another Data
    sanityClient
      .fetch(
        `*[_type=="projects"] | order(_createdAt desc) {
          "name": name.en,
          "slug": Slug.current,
          "imgUrl" : images[0].asset->url
        }[0...3]`
      )
      .then((data) => {
        setAntherProjects(data);
        setLoading(false);
      })
      .catch((err) => console.log(err));
  }, [slug]);

  console.log("render");

  if (loading) {
    return <Loading />
  }

  return (
    <>
      <NavEn url={`/ar/projects/${slug}`} />
      <div className="single">
        {project && (
          <>
            <div className="left">
              <div className="c-img">
                <img src={img || project.images[0]} alt="GT-Home Img" />
              </div>
              <div className="images">
                {project.images.map((image, index) => {
                  return (
                    <img
                      src={image}
                      alt="GT-Home Img"
                      onClick={() => setImg(image)}
                      key={index}
                    />
                  );
                })}
              </div>
            </div>
            <div className="right">
              <h2 className="h2">{project.name}</h2>
              <div className="description">
                <BlockContent blocks={project.description} />
              </div>
            </div>
            <div className="projects">
              <div className="all">
                {antherProjects &&
                  antherProjects.map(({ name, slug, imgUrl }) => {
                    return (
                      <Project
                        img={imgUrl}
                        projectName={name}
                        key={slug}
                        slug={slug}
                      />
                    );
                  })}
              </div>
            </div>
          </>
        )}
      </div>
      <FooterEn />
    </>
  );
}

function Project({ img, projectName, slug }) {
  return (
    <div className="project">
      <Link to={"/projects/" + slug}>
        <img src={img} alt={projectName} />

        <h3>{projectName}</h3>
      </Link>
    </div>
  );
}

export default SingleProject;
